export const autoSizeAllColumns = (gridApi, columnApi) => {
  if (!gridApi || !columnApi) return;

  const allColumns = columnApi.getAllColumns();
  if (!allColumns || !allColumns.length) return;

  columnApi.autoSizeColumns(
    allColumns.map(col => col.getColId()),
    false
  );
};
